<template>
    <b-modal v-model="show" title="ЕР СТАВКАСИ ПАРАМЕТРЛАРИ" :no-close-on-esc="true" :no-close-on-backdrop="true" size="lg">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <div class="form-check form-check-radio checkbox-inline pl-0"
                             style="margin-left:-0.8rem">
                            <label class="form-check-label">
                                <input class="form-check-input" type="radio" name="clientType"
                                       value="Physical" v-model="dictionaryData.data.clientType">
                                <span class="form-check-sign"></span>
                                {{$t("expert2.field.ownerType.physical")}}
                            </label>
                        </div>
                        <div class="form-check form-check-radio checkbox-inline">
                            <label class="form-check-label">
                                <input class="form-check-input" type="radio" name="clientType"
                                       value="Legal" v-model="dictionaryData.data.clientType">
                                <span class="form-check-sign"></span>
                                {{$t("expert2.field.ownerType.legal")}}
                            </label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{$t("realEstate.field.province")}} <span class="red">*</span></label>
                        <v-select
                                label="label"
                                v-model="dictionaryData.data.province"
                                :filterable="false"
                                :options="provinces"
                                @search="onProvinceSearch"
                                @search:focus="onProvinceFocus"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                        <div class="red" v-if="$v.dictionaryData.data.province.id.$error">
                            {{$t("realEstate.validation.province")}}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{$t("realEstate.field.region")}} </label>
                        <v-select
                                label="label"
                                :options="regions"
                                v-model="dictionaryData.data.region"
                                :filterable="false"
                                @search="onRegionSearch"
                                @search:focus="onRegionFocus"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <label>{{$t("realEstate.field.microRegion")}} </label>
                        <v-select label="label"
                                  :options="microRegions"
                                  v-model="dictionaryData.data.microRegion"
                                  @search="onMicroRegionSearch"
                                  @search:focus="onMicroRegionFocus"
                        >
                            <template slot="option" slot-scope="option" v-if="option">
                                <div v-html="option.label"></div>
                            </template>
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label>Зона ва коэффициент</label>
                        <div class="table-responsive">
                          <div class="table-wrapper">
                            <table class="table table-striped" style="min-width: 450px;">
                                <thead>
                                <tr>
                                    <th>Зона</th>
                                    <th>1 гектар учун (млн сўмда)</th>
                                    <th>1 кв.м. учун (сўмда)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-if="dictionaryData.data.childFields && dictionaryData.data.childFields.length > 0">
                                    <tr v-for="(field,index) in dictionaryData.data.childFields" :key="field.id">
                                        <td class="text-center">
                                            <numeric-input class="form-control"
                                                           align="right"
                                                           v-model="field.zone"
                                            />
                                        </td>
                                        <td>
                                            <numeric-input class="form-control"
                                                           :precision="2" align="right"
                                                           v-model="field.hectareValue"
                                                           :class="{invalid : $v.dictionaryData.data.childFields.$each[index].hectareValue.$error}"
                                            />
                                        </td>
                                        <td>
                                            <numeric-input class="form-control"
                                                           :precision="2" align="right"
                                                           v-model="field.value"
                                                           :class="{invalid : $v.dictionaryData.data.childFields.$each[index].value.$error}"
                                            />
                                        </td>
                                    </tr>
                                </template>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right">
                                        <button class="all-btn add-btn icon-btn" @click="addField">+</button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_BUILDING_TAX_RATE_FOR_LAND_ADD')" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {required,minValue} from 'vuelidate/lib/validators';
    import {clone} from '@/shared/utils';
    import initFilterModel from '@/shared/filter';
    import AdvancedFilter from '@/shared/filters/advancedFilter';

    export default {
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                filterMicroRegion: new AdvancedFilter(),
                dictionaryData: this.initData(),
                provinces: [],
                region: {},
                province: {},
                regions: [],
                microRegions: [],
                microRegion: {}
            }
        },
        validations() {
            return {
                dictionaryData: {
                    data: {
                        province: {
                            id: {
                                required
                            }
                        },
                        childFields: {
                            $each: {
                                hectareValue: {
                                    required,
                                    minValue: minValue(0.01)
                                },
                                value: {
                                    required,
                                    minValue: minValue(0.01)
                                }
                            }
                        }
                    }
                }
            }
        },
        computed: {
            getShortProvinces() {
                return this.provinces.map(province =>({id: province.id, label: province.name}))
            }
        },
        methods: {
            initData() {
                return {
                    id: null,
                    dictionaryType: 'TAX_RATE_FOR_LAND',
                    data: {
                        province: null,
                        region: null,
                        microRegion: null,
                        clientType: 'Physical',
                        childFields: [
                            {
                                zone: 0,
                                value: 0,
                                hectareValue: 0
                            }
                        ]
                    }
                }
            },
            addField() {
                this.dictionaryData.data.childFields.push({
                    zone: 0,
                    value: 0,
                    hectareValue: 0
                });
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;
                this.$http.post('dictionary/save', this.dictionaryData)
                    .then(res => {
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$emit('change')
                        }
                        vm.processing = false;
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            cancel() {
                this.show = false;
            },
            onProvinceFocus() {
                this.provinces = [];
                this.filterProvince.search = '';
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
            onProvinceSearch(searchTxt, loading) {
                loading(true);
                this.provinces = [];
                this.filterProvince.search = searchTxt;
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = this.getAsMaps(res.data);
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionSearch(searchTxt, loading) {
                loading(true);
                this.regions = [];
                this.filterRegion.search = searchTxt;
                this.filterRegion.provinceId = (this.dictionaryData.data.province && this.dictionaryData.data.province.id) ? this.dictionaryData.data.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = this.getAsMaps(res.data);
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionFocus() {
                this.regions = [];
                this.filterRegion.provinceId = (this.dictionaryData.data.province && this.dictionaryData.data.province.id) ? this.dictionaryData.data.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
            onMicroRegionFocus() {
                this.microRegions = [];
                this.filterMicroRegion.region = (this.dictionaryData.data.region && this.dictionaryData.data.region.id) ? this.dictionaryData.data.region.id : 0;
                this.$http.post('/uy-joy-api/micro-regions', this.filterMicroRegion.asQuery())
                    .then(res => {
                        this.microRegions = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
            onMicroRegionSearch(searchTxt, loading) {
                loading(true);
                this.microRegions = [];
                this.filterMicroRegion.search = searchTxt;
                this.filterMicroRegion.region = (this.dictionaryData.data.region && this.dictionaryData.data.region.id) ? this.dictionaryData.data.region.id : 0;
                this.$http.post('/uy-joy-api/micro-regions', this.filterMicroRegion.asQuery())
                    .then(res => {
                        this.microRegions = this.getAsMaps(res.data);
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            getAsMaps(result) {
                if (result && result.data && result.data.length > 0) {
                    return result.data.map(d =>({id: d.id, label: d.name}))
                }
                return [];
            }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.filterRegion.page.size = 1000;
            this.filterMicroRegion.pageFilter.size = 1000;

            this.$eventBus.$on('showTaxRatePerLandEditModal', (data) => {
                if (data) {
                    this.dictionaryData = clone(data);
                } else {
                    this.dictionaryData = this.initData();
                }
                this.show = true
            });
        }
    }
</script>

<style scoped>

</style>